///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>


module Meevo.Components.Controls.SmartMover {


    import IReportEmployeeCategory = Meevo.Plugins.Reports.IReportEmployeeCategory;
    import IReportPayrollEmployee = Meevo.Plugins.Reports.IReportPayrollEmployee;

    export class PayrollEmployeeToCategoriesStrategy implements ICollectionPopulate {
        constructor(public parent: ICollectionBase<IReportEmployeeCategory>, public child: ICollectionBase<IReportPayrollEmployee>) {
        }

        populate(): void {
            this.parent.models.forEach((category: ISmartMoverCategoryModel<IReportEmployeeCategory>) => {
                category.resetModels([]);
            });

            for (const category of this.parent.models) {
                (<ISmartMoverCategoryModel<IReportEmployeeCategory>>category).resetModels(
                    this.child.models.filter(model => {
                        const categoriesIds: string[] = model.get('reportPayrollEmployeeCategories').map(row => row.employeeCatId);

                        return categoriesIds.indexOf(category.id as string) !== -1;
                    })
                );
            }
        }
    }
}